import { motion, useReducedMotion } from "framer-motion";
import { Area, AreaChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { CONTROL } from "../../constants/testIds";
import { fadeUp } from "../../lib/motion";

// DEFECT-D-19/D-20 #2: real 12-week trend straight off `organization.created_at` — no fabricated
// data. Single accent-colored area (this is the ONE chart where --scarlet-accent as a fill is
// correct per B0 — it's the platform's own primary growth metric, not a status/health signal).
export function NewGymsTrendChart({ trend, thisWeek, lastWeek, loading }) {
  const reducedMotion = useReducedMotion();
  if (loading || !trend) {
    return <div className="solid-surface rounded-[14px] p-5 h-56 animate-pulse" data-testid={CONTROL.newGymsTrendChart} />;
  }
  const delta = lastWeek > 0 ? Math.round(((thisWeek - lastWeek) / lastWeek) * 100) : (thisWeek > 0 ? 100 : 0);
  const data = trend.map((t) => ({ week: new Date(t.week_start).toLocaleDateString(undefined, { month: "short", day: "numeric" }), new_gyms: t.new_gyms }));

  return (
    <motion.div {...fadeUp(reducedMotion, 0.05)} className="solid-surface rounded-[14px] p-5" data-testid={CONTROL.newGymsTrendChart}>
      <div className="flex items-baseline justify-between mb-1">
        <p className="eyebrow">New gyms (12 weeks)</p>
        <span className="text-xs font-semibold" style={{ color: delta >= 0 ? "var(--scarlet-pos)" : "var(--scarlet-text-secondary)" }}>
          {thisWeek} this week {lastWeek > 0 || thisWeek > 0 ? `(${delta >= 0 ? "+" : ""}${delta}% vs last week)` : ""}
        </span>
      </div>
      <div className="h-40 -ml-2">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
            <defs>
              <linearGradient id="newGymsFill" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="var(--scarlet-accent)" stopOpacity={0.35} />
                <stop offset="100%" stopColor="var(--scarlet-accent)" stopOpacity={0.02} />
              </linearGradient>
            </defs>
            <XAxis dataKey="week" tick={{ fontSize: 10, fill: "var(--scarlet-text-secondary)" }} interval={2} axisLine={false} tickLine={false} />
            <YAxis allowDecimals={false} width={24} tick={{ fontSize: 10, fill: "var(--scarlet-text-secondary)" }} axisLine={false} tickLine={false} />
            <Tooltip formatter={(v) => [`${v} new gym${v === 1 ? "" : "s"}`, "Week of"]} />
            <Area type="monotone" dataKey="new_gyms" stroke="var(--scarlet-accent)" strokeWidth={2} fill="url(#newGymsFill)" isAnimationActive={!reducedMotion} />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </motion.div>
  );
}
